import { ValidationGenerator } from "../../../../../form/validation/validation-generator"
import { UserValidationSetting } from "../../../../../form/validation/validation-setting"
import { IFormField } from "./form-meta"

export const validate = (values: Partial<IFormField>) => {
  const errors: Partial<IFormField> = {}

  const UserScreenNameVal = ValidationGenerator(
    values.screenName,
    UserValidationSetting.screenName,
  )
  const UserNameVal = ValidationGenerator(
    values.name,
    UserValidationSetting.name,
  )
  const UserEmailVal = ValidationGenerator(
    values.email,
    UserValidationSetting.email,
  )

  if (UserScreenNameVal) {
    errors.screenName = UserScreenNameVal
  }

  if (UserNameVal) {
    errors.name = UserNameVal
  }

  if (UserEmailVal) {
    errors.email = UserEmailVal
  }

  if (!values.agreementCheck) {
    errors.agreementCheck = "登録するには同意する必要があります"
  }

  return errors
}
